import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { tap, withLatestFrom } from 'rxjs/operators';
import { StorageTypes } from '@morningstar/shared/base/storage-service';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { TokenService } from '@morningstar/shared/auth';
import { ILocation } from '@morningstar/shared/services/locations';
import { LocationType } from '@morningstar/shared/services/locations';
import { LocationsService } from '@morningstar/shared/services/locations';

@Component({
  selector: 'wsg-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationsComponent implements OnInit {

  // == SOURCE ===========================================================

  @Input() label = 'Location';
  @Input() type: LocationType = LocationType.Standard;
  @Input() includeAll = false;
  @Input() isOptional = false;
  @Input() showDefaultOption = true;
  @Input() value = '';
  @Input() disabled = false;
  @Input() formPropertyName = 'location';

  locations = new Subject<ILocation[]>();
  locations$ = this.locations.asObservable();

  processing$ = new BehaviorSubject(false);
  location: string;
  @Input() parent: FormGroup;

  @Output() locationDescriptionChange = new EventEmitter<string>();

  // == LIFECYCLE ===============================================================

  constructor(private locationService: LocationsService,
              private storageService: StorageService, private tokenService: TokenService) {
  }

  ngOnInit() {
    this.parent.get(this.formPropertyName).valueChanges.pipe(
      withLatestFrom(this.locations$),
      tap(([value, locations]) => {
        if (typeof value === 'undefined') {
          this.parent.patchValue({location: ''});
        } else {
          var location = locations.find(l => l.id === value);

          const locationDescription = location ? location.description : 'None';
          this.locationDescriptionChange.emit(locationDescription);
        }
      })
    ).subscribe();

    const that = this;

    this.processing$.next(true);
    this.locationService.get(this.includeAll, this.type)
                        .subscribe(locations => {

                          if (!that.isOptional || that.showDefaultOption) {

                            let location = that.storageService.getItem(StorageTypes.location);

                            if (!location) {
                              location = that.tokenService.getDefaultLocation();
                            }

                            if (!this.parent.get(this.formPropertyName).value) {
                              if (that.value) {
                                that.parent.patchValue({
                                  location: that.value
                                });
                              } else {
                                that.parent.patchValue({
                                  location: location != null ? location : locations[0].id
                                });
                              }
                            }

                            const selectedLocation = locations.find(l => l.id === location);

                            let locationDescription = '';
                            if (selectedLocation) {
                              locationDescription = selectedLocation.description;
                            }

                            this.locationDescriptionChange.emit(locationDescription);
                          }

                          this.locations.next(locations);
                          this.processing$.next(false);
                        }, error => {
                          this.processing$.next(false);
                        });
  }
}
